import { render, staticRenderFns } from "./monospace_block.vue?vue&type=template&id=36bc97c1&"
import script from "./monospace_block.vue?vue&type=script&lang=js&"
export * from "./monospace_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports